import React from 'react'
import Footer from '../../Components/Footer/Footer'
import Header from '../../Components/Header/Header'
import About from './Components/About/About'
import Clients from './Components/Clients/Clients'
import Control from './Components/Control/Control'
import Email from './Components/Email/Email'
import HomeSwipper from './Components/HomeSwiper/HomeSwiper'
import LearnMore from './Components/LearnMore/LearnMore'
import Main from './Components/Main/Main'
import Partner from './Components/Partner/Partner'
import Private from './Components/Private/Private'
import Process from './Components/Process/Process'
import Quality from './Components/Quality/Quality'
import Team from './Components/Team/Team'
import "./HomePage.css";

export default function HomePage() {
  return (
    <div>
        <Header />
        <Main />
        <HomeSwipper />
        <LearnMore />
        <Quality />   
        <Partner />
        <Process />
        <About />
        <Clients />
        <Private />
        <Control />
        <Team />
        <Email />
        <Footer /> 
    
    </div>
  )
}
